<template>
  <button
    class="p-1.5 w-7.5 h-7.5 rounded-lg border border-gray-200 flex items-center justify-center"
    :disabled="isReadonly || isLoading"
    @click.stop="emit('toggleFavorite')"
  >
    <i-material-symbols-progress-activity
      v-if="isLoading"
      class="w-4 h-4 animate-spin text-mid-neutral-500"
    />
    <StarIcon
      v-else
      class="w-4 h-4 stroke-1.5"
      :class="[
        study.isFavorite
          ? 'fill-amber-400 stroke-amber-400'
          : 'fill-transparent stroke-mid-neutral-500',
      ]"
    />
  </button>
</template>
<script lang="ts" setup>
import StarIcon from "@app/components/Icons/StarIcon.vue";
import { ReviewItem } from "@core/domain/models/reviewItem.model";

defineProps<{ study: ReviewItem; isReadonly: boolean; isLoading?: boolean }>();

const emit = defineEmits<(e: "toggleFavorite") => void>();
</script>
